var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-color-picker"},_vm._l((Object.keys(_vm.bgColors)),function(clr,index){return _c('div',{key:index,class:("color bg-" + clr),on:{"click":function($event){return _vm.$emit('input', clr)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }